import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { fetchCurrentUser, generateQr, verify2fa } from "../../api";
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../constants";
import { AppContext } from "../../AppContext";
import { AuthContext } from "../../AuthContext";

export function QrForm() {
  const { username, setUsername, password, setPassword } =
    useContext<any>(AuthContext);

  const [localUsername, setLocalUsername] = useState<string>("");
  const [localPwd, setLocalPwd] = useState<string>("");

  const [qrUrl, setQrUrl] = useState<string>("");
  const [errorMsg, setErrorMsg] = useState<string>("");

  const [code, setCode] = useState<string>("");
  const [verify2faError, setVerify2faError] = useState<string>("");

  const { setContext } = useContext(AppContext);
  const navigate = useNavigate();

  const qrMutation = useMutation<any>({
    mutationFn: () => generateQr(localUsername, localPwd),
    onSuccess: (data) => {
      setQrUrl(URL.createObjectURL(data));
    },
    onError: (error: any) => {
      const err = error.response.data?.error;
      if (err) {
        setErrorMsg(err);
      } else {
        setErrorMsg("Errore durante la verifica del codice.");
      }
    },
  });

  const navigateToHome = async () => {
    const user = await fetchCurrentUser();
    localStorage.setItem("user", JSON.stringify(user));
    setContext();
    navigate("/");
  };

  const verify2faMutation = useMutation<any>({
    mutationFn: () => verify2fa(localUsername, localPwd, code),
    onSuccess: (data) => {
      localStorage.setItem(ACCESS_TOKEN, data.access);
      localStorage.setItem(REFRESH_TOKEN, data.refresh);
      navigateToHome();
    },
    onError: (error: any) => {
      const err = error.response.data?.detail;
      if (err) {
        setVerify2faError(err);
      } else {
        setVerify2faError("Errore durante la verifica del codice.");
      }
    },
  });

  useEffect(() => {
    if (!username || !password) {
      navigate("/login");
    }

    setLocalUsername(username);
    setLocalPwd(password);
    setUsername("");
    setPassword("");
  }, []);

  useEffect(() => {
    if (localUsername && localPwd) {
      qrMutation.mutate();
    }
  }, [localUsername, localPwd]);

  return (
    <>
      <div
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          paddingTop: "2rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <p style={{ maxWidth: "30rem" }}>
          Scarica un'app per l'autenticazione 2fa (Microsoft Authenticator,
          Google Authenticator...) e scannerizza il codice qr
        </p>
        {qrMutation.isPending && <p>Loading...</p>}
        {qrMutation.isError && <p style={{ color: "red" }}>{errorMsg}</p>}
        {qrMutation.isSuccess && (
          <div style={{ marginTop: "2rem" }}>
            <p style={{ marginBottom: "1rem" }}>
              {"Non chiudere questa finestra finché non si è scannerizzato il codice qr!".toUpperCase()}
            </p>
            <img style={{ margin: "0 auto", maxWidth: "15rem" }} src={qrUrl} />
          </div>
        )}
        <form
          style={{
            margin: "0 auto",
            display: "flex",
            gap: "1rem",
            alignItems: "center",
          }}
        >
          <label>Codice temporaneo: </label>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e: any) => setCode(e.target.value)}
          />
          <button
            className="button_var1"
            onClick={(e: any) => {
              e.preventDefault();
              verify2faMutation.mutate();
            }}
          >
            Invia
          </button>
        </form>
        {verify2faMutation.isError && (
          <p style={{ color: "red" }}>{verify2faError}</p>
        )}
      </div>
    </>
  );
}
